export default () => ({
  coreMap: { height: '100%', width: '50%' },
  fillScreen: {
    width: '100% !important',
  },
});
